import { deleteDB as deleteDB$1, openDB } from 'idb';
import { FLEX_CACHE_DB_NAME, FLEX_CACHE_PREVIOUS_DB_NAME, FLEX_CACHE_DB_METADATA_STORE_NAME, FLEX_CACHE_DB_VERSION, FLEX_CACHE_DB_STORE_NAME } from '../core/meta.mjs';

const initializeDB = async () => {
  if (!("indexedDB" in window)) {
    return {
      isDBInitialized: false,
      hasData: false
    };
  }
  deleteDB$1(FLEX_CACHE_PREVIOUS_DB_NAME).catch(() => null);
  try {
    const db = await getDB();
    const count = await db.count(FLEX_CACHE_DB_METADATA_STORE_NAME);
    db.close();
    return {
      isDBInitialized: true,
      hasData: count !== 0
    };
  } catch {
    return {
      isDBInitialized: false,
      hasData: false
    };
  }
};
const getDB = () => {
  return openDB(FLEX_CACHE_DB_NAME, FLEX_CACHE_DB_VERSION, {
    upgrade(idb, oldVersion) {
      if (oldVersion < FLEX_CACHE_DB_VERSION) {
        if (idb.objectStoreNames.contains(FLEX_CACHE_DB_METADATA_STORE_NAME)) {
          idb.deleteObjectStore(FLEX_CACHE_DB_METADATA_STORE_NAME);
        }
        if (idb.objectStoreNames.contains(FLEX_CACHE_DB_STORE_NAME)) {
          idb.deleteObjectStore(FLEX_CACHE_DB_STORE_NAME);
        }
      }
      if (!idb.objectStoreNames.contains(FLEX_CACHE_DB_METADATA_STORE_NAME)) {
        idb.createObjectStore(FLEX_CACHE_DB_METADATA_STORE_NAME);
      }
      if (!idb.objectStoreNames.contains(FLEX_CACHE_DB_STORE_NAME)) {
        idb.createObjectStore(FLEX_CACHE_DB_STORE_NAME);
      }
    }
  });
};
const deleteDB = async () => {
  await deleteDB$1(FLEX_CACHE_DB_NAME);
};

export { deleteDB, getDB, initializeDB };
//# sourceMappingURL=dbInstance.mjs.map
